import { render, staticRenderFns } from "./DialogConsentGeneralOnePlatformCreate.vue?vue&type=template&id=7b461c3a&scoped=true&"
import script from "./DialogConsentGeneralOnePlatformCreate.vue?vue&type=script&lang=js&"
export * from "./DialogConsentGeneralOnePlatformCreate.vue?vue&type=script&lang=js&"
import style0 from "./DialogConsentGeneralOnePlatformCreate.vue?vue&type=style&index=0&id=7b461c3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b461c3a",
  null
  
)

export default component.exports